import invalidateBoxQueries from 'admin/invalidateBoxQueries';
import { GetUserToken, useAuth } from 'components/AuthProvider';
import { UpsertAdminBoxMutationVariables } from 'generated/graphql';
import { GraphQLError } from 'graphql-request/dist/types';
import { getClientSdk } from 'graphql/client';
import { useSnackbar } from 'notistack';
import { MutationFunction, useMutation } from 'react-query';

const insertAdminBox = (
  getUserToken: GetUserToken,
  userId: string | null
): MutationFunction<string, UpsertAdminBoxMutationVariables> => async (
  vars
) => {
  const token = await getUserToken();

  const data = await getClientSdk(token).UpsertAdminBox({
    box: { ...vars.box, user_id: userId },
  });
  return data.insert_box_one?.imei ?? '';
};

const useInsertAdminBox = (closeDialog: () => void) => {
  const { getUserToken } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const userId = useAuth().getUserId();

  return useMutation<string, GraphQLError, UpsertAdminBoxMutationVariables>(
    insertAdminBox(getUserToken, userId),
    {
      onSuccess: (imei) => {
        closeDialog();
        invalidateBoxQueries();
        enqueueSnackbar(`ボックス ${imei}が追加できました`, {
          variant: 'success',
          autoHideDuration: 5000,
        });
      },
      onError: (error, vars) => {
        enqueueSnackbar(`ボックス ${vars.box.imei} 追加　エラー`, {
          variant: 'error',
        });
      },
    }
  );
};

export default useInsertAdminBox;
